(async () => {
  const currentPath = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const publicPages = ['/login.html', 'login.html', '/register.html', 'register.html', '/share.html', 'share.html', '/index.html', 'index.html', '/'];
  const isPublicPage = publicPages.includes(currentPath) || 
                       currentPath.endsWith('/login.html') || 
                       currentPath.endsWith('/register.html') ||
                       currentPath.endsWith('/share.html') ||
                       currentPath === '/' ||
                       currentPath === '/index.html';

  // /viewer (and /viewer.html) is a public page WHEN accessed via a share
  // link (?share=<id>). Regular access still requires login so people can
  // browse their own models, but a shared URL is consumable by anyone.
  const isViewerPath = currentPath === '/viewer' || currentPath.endsWith('/viewer.html');
  const isSharedViewer = isViewerPath && !!urlParams.get('share');

  if (isPublicPage || isSharedViewer) {
    removeLoadingOverlay();
    return;
  }

  const token = sessionStorage.getItem('token');

  if (!token) {
    redirectToLogin();
    return;
  }

  try {
    const authApiUrl = getAuthApiUrl();

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(`${authApiUrl}/api/auth/me`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include',
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    if (!data.success) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      redirectToLogin();
      return;
    }

    // 保存 userInfo 到 localStorage（供 WebSocket 使用）
    if (data.user) {
      const userInfo = {
        userId: data.user.userId,
        username: data.user.username,
        displayName: data.user.displayName
      };
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
    
    removeLoadingOverlay();

  } catch (error: any) {
    console.error('❌ Authentication failed');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    redirectToLogin();
  }
})();

function removeLoadingOverlay() {
  const removeOverlay = () => {
    const overlay = document.getElementById('auth-loading-overlay');
    if (overlay) {
      overlay.remove();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeOverlay);
  } else {
    removeOverlay();
  }

  setTimeout(() => {
    const overlay = document.getElementById('auth-loading-overlay');
    if (overlay) {
      overlay.remove();
    }
  }, 10000);
}

function redirectToLogin() {
  const currentPath = window.location.pathname;
  const redirectParam = encodeURIComponent(currentPath + window.location.search);
  const loginPath = currentPath.includes('/') ? 'login.html' : '/login.html';
  window.location.href = `${loginPath}?redirect=${redirectParam}`;
}

function getAuthApiUrl(): string {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3002';
  }
  
  return `${protocol}//${hostname}`;
}
